"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRenderable = exports.getComponentPropType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createChainablePropType = _interopRequireDefault(require("./createChainablePropType"));

var getComponentPropType = function getComponentPropType(_ref) {
  var propTypes = _ref.propTypes,
      defaultProps = _ref.defaultProps;
  return (0, _createChainablePropType.default)(_propTypes.default.elementType, 'componentProp', {
    propTypes: propTypes,
    defaultProps: defaultProps
  });
};

exports.getComponentPropType = getComponentPropType;

var isRenderable = function isRenderable(children) {
  return children != null && children !== false;
};

exports.isRenderable = isRenderable;